import { useCartModal } from "@/context/CartModalContext";
import { useCart } from "@/hooks/useCart";
import { useEffect, useRef } from "react";
import styles from "./CartModal.module.scss";

const CartModal = () => {
  const { isOpen, closeCart } = useCartModal();
  const { cart, removeFromCart } = useCart();

  const modalRef = useRef<HTMLDivElement>(null);

  // Закриття по Escape
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeCart();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeCart]);

  // Розділяємо товари за типом "sellpart" та "exchpart"
  const sellPartItems = cart.filter((item) => item.typeorder === "sellpart");
  const exchPartItems = cart.filter((item) => item.typeorder === "exchpart");

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} ref={modalRef}>
        <p className={styles.title}>Mein Warenkorb</p>
        <button className={styles.closeBtn} onClick={closeCart}>
          <img src="/images/close.svg" alt="Close button" />
        </button>

        {cart.length === 0 ? (
          <p className={styles.titleInfo}>
            Es befinden sich keine Produkte im Warenkorb.
          </p>
        ) : (
          <div className={styles.items}>
            {/* Відображаємо товари з typeorder = "sellpart" */}
            {sellPartItems.length > 0 && (
              <div>
                {sellPartItems.map((item) => (
                  <div className={styles.item} key={item.goid}>
                    <img
                      src={item.imageUrl || "/images/Shop/template.webp"}
                      alt={item.name}
                    />
                    <div className={styles.info}>
                      <p className={styles.name}>{item.name}</p>
                      <div className={styles.priceBlock}>
                        <p>
                          {item.quantity} × {item.price} €
                        </p>
                        <p>{item.typeorder}</p>
                      </div>

                      <button
                        className={styles.deleteBtn}
                        onClick={() =>
                          removeFromCart(item.goid, item.typeorder)
                        }
                        aria-label="Artikel aus dem Warenkorb entfernen"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Відображаємо товари з typeorder = "exchpart" */}
            {exchPartItems.length > 0 && (
              <div>
                {exchPartItems.map((item) => (
                  <div className={styles.item} key={item.goid}>
                    <img
                      src={item.imageUrl || "/images/Shop/template.webp"}
                      alt={item.name}
                    />
                    <div className={styles.info}>
                      <p className={styles.name}>{item.name}</p>
                      <div className={styles.priceBlock}>
                        <p>
                          {item.quantity} × {item.price} €
                        </p>
                        <p>{item.typeorder}</p>
                      </div>

                      <button
                        className={styles.deleteBtn}
                        onClick={() =>
                          removeFromCart(item.goid, item.typeorder)
                        }
                        aria-label="Artikel aus dem Warenkorb entfernen"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {cart.length > 0 && (
          <div className={styles.footer}>
            <div className={styles.footerLine}>
              <div className={styles.total}>
                <p>Zwischensumme:</p>
                <p className={styles.totalPrice}>
                  {cart
                    .reduce((acc, item) => acc + item.price * item.quantity, 0)
                    .toFixed(2)}{" "}
                  €
                </p>
              </div>
            </div>
            <button
              className={styles.checkoutBtn}
              onClick={() => (window.location.href = "/checkout")}
            >
              Kasse
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartModal;
